import React, { useState, useEffect } from "react";
import Page from "../../components/Page/Page";
import {
  Form,
  Input,
  Col,
  Row,
  Select,
  Tabs,
  Button,
  Modal,
  message,
} from "antd";
import {
  FileAddOutlined,
  SaveOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";

import { GetCustomers } from "../../API/customer";
import { GetProducts, GetProductGoroups,GetGifts } from "../../API/products";

import "./index.css";

const ErrorModal = Modal.error;
const InputGroup = Input.Group;
const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
export default function Settings() {
  const [itemsCatalogShow, setItemsCatalogShow] = useState(
    itemsCatalogCheck(JSON.parse(localStorage.getItem("privilage")))
  );
  const [buttonLoading, setButtonLoading] = useState(false);

  function itemsCatalogCheck(v) {
    let result = [];

    if (v.fee1) {
      result.push("fee1");
    }
    if (v.fee2) {
      result.push("fee2");
    }
    if (v.fee3) {
      result.push("fee3");
    }
    if (v.fee4) {
      result.push("fee4");
    }
    if (v.price5) {
      result.push("price5");
    }
    if (v.content) {
      result.push("content");
    }
    if (v.pac) {
      result.push("pac");
    }
    if (v.pac2) {
      result.push("pac2");
    }
    if (v.count) {
      result.push("count");
    }

    return result;
  }
  function itemsCatalogCheck2(value) {
    let result = {
      fee1: false,
      fee2: false,
      fee3: false,
      fee4: false,
      price5: false,
      content: false,
      pac: false,
      pac2: false,
      count: false,
    };

    value.map((v) => {
      switch (v) {
        case "fee1":
          result.fee1 = true;
          break;
        case "fee2":
          result.fee2 = true;
          break;
        case "fee3":
          result.fee3 = true;
          break;
        case "fee4":
          result.fee4 = true;
          break;
        case "price5":
          result.price5 = true;
          break;
        case "content":
          result.content = true;
          break;
        case "pac":
          result.pac = true;
          break;
        case "pac2":
          result.pac2 = true;
          break;
        case "count":
          result.count = true;
          break;
      }
    });
    return result;
  }
  function onFinishHandler(values) {
    localStorage.setItem(
      "privilage",
      JSON.stringify(itemsCatalogCheck2(values.stock))
    );

    message.success("تنظیمات ثبت شد");
  }
  function productGetter() {
    setButtonLoading(true);
    GetProducts()
      .then((i) => {
        if (i.success) {
          message.success("کالا ها دریافت شدند");
        } else {
          message.error("عملیات با مشکل مواجه شد");
        }
      })
      .catch((e) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد" + e,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      })
      .finally(() => {
        GetProductGoroups()
          .then((i) => {
            if (i.success) {
              message.success("گروه کالا ها دریافت شد");
            } else {
              message.error("عملیات با مشکل مواجه شد");
            }
          })
          .finally(() => {
            setButtonLoading(false);
          })
          .catch((e) => {
            ErrorModal({
              title: "خطا",
              content: "مشکلی هنگان انجام عمیلات رخداد" + e,
              okText: "باشد",
              okType: "danger",
              onOk() {},
            });
          });
      });
  }
  function CustomersGetter() {
    setButtonLoading(true);
    GetCustomers()
      .then((i) => {
        if (i.success) {
          message.success("مشتریان دریافت شدند");
        } else {
          message.error("عملیات با مشکل مواجه شد");
        }
      })
      .finally(() => {
        setButtonLoading(false);
      })
      .catch((e) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد" + e,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      });
  }
  const formItemState = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    labelAlign: "right",
  };
  return (
    <Page>
      <Form
        initialValues={{ remeber: true }}
        onFinish={onFinishHandler}
        onFinishFailed={() => {
          Modal.error({
            title: "خطا",
            content: "مشکلی هنگام انجام عملیات رخداد",
          });
        }}
        layout="inline"
      >
        <Row className="gx-mb-3" key="settingItems">
          <Col key="stock" lg={12} md={24} sm={24}>
            <FormItem
              label="توضیحات کالا"
              name="stock"
              {...formItemState}
              initialvalues={itemsCatalogShow}
            >
              <Select
                mode="multiple"
                showSearch
                defaultValue={itemsCatalogShow}
                value={itemsCatalogShow}
                onChange={(e) => {
                  setItemsCatalogShow(e);
                }}
              >
                <Option value={"fee1"}>فی فروش1</Option>
                <Option value={"fee2"}>فی فروش2</Option>
                <Option value={"fee3"}>فی فروش3</Option>
                <Option value={"fee4"}>فی فروش4</Option>
                <Option value={"price5"}>فی فروش5</Option>
                <Option value={"content"}>محتوا</Option>
                <Option value={"pac"}>بسته</Option>
                <Option value={"pac2"}>جزء</Option>
                <Option value={"count"}>تعداد</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row
          style={{
            display: "block",
            width: "100%",
            direction: "rtl",
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            loading={buttonLoading}
            className="gx-mx-1"
          >
            <SaveOutlined />
            ثبت
          </Button>
        </Row>
      </Form>
      <Row>
        <InputGroup compact>
          <Button
            type="primary"
            loading={buttonLoading}
            onClick={productGetter}
            className="gx-mx-1"
          >
            <CloudDownloadOutlined />
            دریافت کالاها
          </Button>
          <Button
            type="primary"
            loading={buttonLoading}
            onClick={CustomersGetter}
            className="gx-mx-1"
          >
            <CloudDownloadOutlined />
            دریافت مشتریان
          </Button>
        </InputGroup>
      </Row>
    </Page>
  );
}
